import { Button, Chip, Grid, IconButton, Menu, MenuItem, } from '@material-ui/core';
import { Description, Event, Group, HomeWork, Mail, MoreHoriz, Room, Work } from '@material-ui/icons';
import { getAbsenceHoursByStudentIdAndClassroomId, getClassesById } from '@webapps/business';
import { useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import AvatarStudent from 'components/Avatar/AvatarStudent';;
import AffiliateInfo from './Affiliation';
import TableActions from './TableActions';

/**
 * Composant modal pour déclarer une absence.
 *
 * @param {boolean} props.hideAbsence - Indique si on affiche les heures d'absence du candidat, le bouton voir le planning etc... Corresponds en faite a : est-ce que l'étudiant a une classe (oui le nom est a changer lol).
 * @param {function} props.addAbsence - Fonction pour ajouter une absence.
 * @param {string} props.classId - L'identifiant de la classe.
 * @returns {JSX.Element} Le composant modal pour déclarer une absence.
 */
const CandidatsCard = ({ item, refetch, id, deleteMember, classId, viewMember, viewPlanning, contactMember, hideAbsence, addAbsence }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const {
    data: absenceHours = {},
    refetch: refetchAbsenceHours,
    isLoading: isLoadingAbsenceHours,
  } = useQuery(getAbsenceHoursByStudentIdAndClassroomId, {
    key: ['absenceHoursBusiness', id],
    variables: { studentId: id, classId },
  });

  function roundToPreviousHalf(number) {
    return Math.floor(number * 2) / 2;
  }

  function pluralize(word, count) {
    return count >= 2 ? `${word}s` : word;
  }



  return (
    <Grid item xs={12} md={4} lg={3} style={{ padding: spacing(2.5, 2.5, 0, 0) }}>
      <div>
        <div style={{ padding: spacing(2.5), borderRadius: 10, backgroundColor: '#FFF', }} >
          <div >
            <div>
              <div className={classes.infoCandidat}>
                <div>
                  <AvatarStudent applicant={item?.student} />
                </div>
                <div
                  className={css({
                    marginLeft: spacing(1.5),
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    width: '100%',
                  })}
                >
                  <div
                    className={classes.divStudent}
                  >
                    <div style={{ display: 'flex' }} className={global.title}>
                      {item?.student?.firstname}
                      {' '}
                      {item?.student?.lastname}
                    </div>
                    <div>
                      <TableActions
                        contactMember={contactMember}
                        deleteMember={deleteMember}
                        id={id}
                        viewMember={viewMember}
                        addAbsence={() => addAbsence(id, classId, refetchAbsenceHours)} // Passer `refetchAbsenceHours`
                        hideAbsence={hideAbsence}
                        refetchAbsenceHours={refetchAbsenceHours}
                      />
                    </div>
                  </div>
                  <div className={cx(classes.address, global.infoText)}>
                    <Room className={global.infoIcon} />
                    {item?.student?.address?.cityCode}{' '}
                    {item?.student?.address?.city}
                  </div>
                  
                </div>
                
              </div>
            </div>
            <div>
              <Grid className={cx(classes.address, global.infoText)} style={{ marginTop: spacing(1) }} >
                <AffiliateInfo id={item?.student?.id}
                  school={item?.student?.classroom?.school?.name}
                  refetch={refetch}
                  absenceHours={absenceHours}
                  />
              </Grid>
              <Grid>
                <Button onClick={() => viewMember(id)}
                  className={css({ marginTop: spacing(2.5), width: '100%', fontWeight: 600 })}
                  style={{ color: '#5A6DA1', padding: spacing(1) }}
                  variant='outlined'
                >
                  Voir les détails
                </Button>
                {!hideAbsence && <Button onClick={() => viewPlanning(id)}
                  className={css({ marginTop: spacing(2.5), width: '100%', fontWeight: 600 })}
                  style={{ color: '#5A6DA1', padding: spacing(1) }}
                  variant='outlined'
                  
                >
                  Voir le planning
                </Button>}
              </Grid>
            </div>
          </div>
        </div>
      </div>
    </Grid>
  )
}



const styles = ({ spacing }) => ({
  formations: {
    marginTop: spacing(2),
  },
  infoCandidat: { display: 'flex', alignItems: 'center', width: '100%' },
  tableHead: {
    '&.MuiTableCell-head': {
      color: 'white',
    },
  },
  address: {
    marginTop: spacing(0.5),
    display: 'flex',
    alignItems: 'center',
  },
  chip: {
    marginTop: spacing(2),
    padding: spacing(2.5),
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 'regular',
    '@media only screen and (max-width:768px)': { fontSize: 12, padding: 0, maring: 0 },
  },
  divStudent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
  }
});

export default CandidatsCard